import script from "./DocumentCompanyAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentCompanyAddress.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentCompanyAddress.vue?vue&type=style&index=0&id=25fe7dff&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25fe7dff"]])

export default __exports__